module.exports = __webpack_public_path__ + "img/avatar5.6a4315e7.png";